module.exports = __webpack_public_path__ + "media/long-normal-clapping.382da148.mp3";